/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signupstatefull2Inputs */

const en_signupstatefull2 = /** @type {(inputs: Signupstatefull2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fully booked`)
};

const de_signupstatefull2 = /** @type {(inputs: Signupstatefull2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ausgebucht`)
};

/**
* | output |
* | --- |
* | "Fully booked" |
*
* @param {Signupstatefull2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const signupstatefull2 = /** @type {((inputs?: Signupstatefull2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signupstatefull2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_signupstatefull2(inputs)
	return de_signupstatefull2(inputs)
});
export { signupstatefull2 as "signupStateFull" }